// Styles
import './style.css';
import { colors } from '../../styles/theme';
import { FemeninoIcon } from '../../../assets/icons/femenino.icon';
import { MasculinoIcon } from '../../../assets/icons/masculino.icon';
import { cn } from '../../../lib';

const { white } = colors;

const ButtonCards = ({
  enabled = false,
  icon = null,
  id = '',
  label = '',
  descripcion = '',
  size = 200,
  value = '',
  onClick = () => null,
  errorAlert = false,
}) => {
  const handleClick = () => {
    !enabled && onClick();
  };

  return (
    <div>
      <div
        className="m-2 flex flex-col items-center card-buttom gap-3"
        style={{ maxWidth: '200px' }}
      >
        <div
          className="flex justify-center items-center card-buttom-opc"
          style={{ width: size, height: size }}
        >
          <div
            className={`asegurame-rb-icon ${
              value === id
                ? 'asegurame-rb-icon-selected asegurame-select-icon '
                : 'asegurame-card' + id
            }`}
            id={id}
            onClick={handleClick}
            style={{
              backgroundColor: !enabled ? white : 'var(--color-outline)',
              border: errorAlert && '2px solid var(--color-danger)',
            }}
          >
            {label === 'Femenino' ? (
              <FemeninoIcon
                className={cn(
                  'size-16 md:size-20',
                  value === id ? 'text-secondary' : 'text-primary',
                )}
              />
            ) : label === 'Masculino' ? (
              <MasculinoIcon
                className={cn(
                  'size-16 md:size-20',
                  value === id ? 'text-secondary' : 'text-primary',
                )}
              />
            ) : (
              <img
                src={icon}
                alt={label}
                style={{ width: 80, height: 80 }}
                className={`${value === id ? 'filter-selected' : ''}`}
              />
            )}
          </div>
        </div>
        <div className="flex flex-col">
          <span className="fontPSemiBold text-base color-primary">{label}</span>
          <span className="fontPRegular text-sm color-primary lg:text-primary-content">
            {descripcion}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ButtonCards;
